import React from 'react'
import { Container } from 'reactstrap'

import Welcomegreet from 'components/Welcomegreet'
import Contactusform from './Contactusform'

function Contactus() {
  return (
    <React.Fragment>
    <div className="page-content">
         <Container fluid>
              <Welcomegreet/>
              <Contactusform/>
         </Container>
    </div>
    </React.Fragment>
  )
}

export default Contactus